"use client";
import React from "react";

function NavigationLinks({ isRegisterPage }) {
  const menuItems = [
    // { label: "Nossos Planos", target: "nossos-planos", type: "scroll" },
    isRegisterPage
      ? { label: "Nossos Planos", url: "/", type: "link" } // muda aqui
      : { label: "Nossos Planos", target: "nossos-planos", type: "scroll" },
    { label: "Rede Credenciada", url: "https://nacaosaude.centraldeatendimento.me/rede", type: "link" },
    { label: "Meu Clube", url: "https://nacaosaude.clubeparcerias.com.br/member/login", type: "link" },
    { label: "Entre em Contato", url: "https://api.whatsapp.com/send/?phone=5511916235625&text=Oi%2C+estou+precisando+de+atendimento&type=phone_number&app_absent=0", type: "link" },
    // { label: "Política de privacidade", url: "/politica-de-privacidade", type: "link" },
    // { label: "Blog", url: "/blog", type: "link" },
  ];

  const handleScroll = (e, targetId) => {
    e.preventDefault();
    const el = document.getElementById(targetId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <nav className="d-flex flex-wrap gap-3 align-items-start justify-content-center">
      <style jsx>{`
        .nav-link-custom {
          color: #d4d4d8;
          text-decoration: none;
          cursor: pointer;
          transition: color 0.3s ease;
          font-size: 1rem;
          line-height: 1.75;
        }
        .nav-link-custom:hover {
          color: white;
        }
        @media (max-width: 768px) {
          .nav-link-custom {
            font-size: 0.875rem;
            line-height: 1.5;
          }
        }
        @media (max-width: 576px) {
          .navigation-container {
            flex-direction: column;
            gap: 1rem;
            align-items: center;
            text-align: center;
            width: 100%;
          }
          .nav-link-custom {
            font-size: 0.875rem;
            line-height: 1.25;
            display: block;
            width: 100%;
            text-align: center;
          }
        }
      `}</style>

      <div className="navigation-container d-flex flex-wrap gap-3 align-items-center justify-content-center w-100">
        {menuItems.map((item, index) =>
          item.type === "scroll" ? (
            <a
              key={index}
              href={`#${item.target}`}
              onClick={(e) => handleScroll(e, item.target)}
              className="nav-link-custom"
            >
              {item.label}
            </a>
          ) : (
            <a
              key={index}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link-custom"
            >
              {item.label}
            </a>
          )
        )}
      </div>
    </nav>
  );
}

export default NavigationLinks;